import { CLessonInCourse } from '@yandex-int/k-common';
// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';

import * as constants from './constants';

export const getDraftsRequest = (courseId: number, sortKey: number | null) =>
    <const>{ type: constants.GET_DRAFTS_REQUEST, courseId, sortKey };

export const getDraftsSuccess = (
    courseId: number,
    oldSortKey: number | null,
    newSortKey: number | null,
    lessons: Array<CLessonInCourse>
) => <const>{ type: constants.GET_DRAFTS_SUCCESS, courseId, lessons, oldSortKey, newSortKey };

export const getDraftsError = (courseId: number) => <const>{ type: constants.GET_DRAFTS_ERROR, courseId };

export const getCompletedLessonsRequest = (courseId: number, onSuccess?: (clessons: Array<CLessonInCourse>) => void) =>
    <const>{ type: constants.GET_COMPLETED_LESSONS_REQUEST, courseId, onSuccess };

export const getCompletedLessonsSuccess = (
    courseId: number,
    oldSortKey: number | null,
    newSortKey: number | null,
    lessons: Array<CLessonInCourse>
) => <const>{ type: constants.GET_COMPLETED_LESSONS_SUCCESS, courseId, lessons, oldSortKey, newSortKey };

export const getCompletedLessonsError = (courseId: number) =>
    <const>{ type: constants.GET_COMPLETED_LESSONS_ERROR, courseId };

export const getActiveLessonsRequest = (courseId: number, onSuccess?: (clessons: Array<CLessonInCourse>) => void) =>
    <const>{ type: constants.GET_ACTIVE_LESSONS_REQUEST, courseId, onSuccess };

export const getActiveLessonsSuccess = (courseId: number, lessons: Array<CLessonInCourse>, sortKey: number | null) =>
    <const>{ type: constants.GET_ACTIVE_LESSONS_SUCCESS, courseId, lessons, sortKey };

export const getActiveLessonsError = (courseId: number) =>
    <const>{ type: constants.GET_ACTIVE_LESSONS_ERROR, courseId };

export const getAssignedLessonsRequest = (courseId: number, onSuccess?: (clessons: Array<CLessonInCourse>) => void) =>
    <const>{ type: constants.GET_ASSIGNED_LESSONS_REQUEST, courseId, onSuccess };

export const getAssignedLessonsSuccess = (courseId: number, lessons: Array<CLessonInCourse>, sortKey: number | null) =>
    <const>{ type: constants.GET_ASSIGNED_LESSONS_SUCCESS, courseId, lessons, sortKey };

export const getAssignedLessonsError = (courseId: number) =>
    <const>{ type: constants.GET_ASSIGNED_LESSONS_ERROR, courseId };

export const clearLessons = () => <const>{ type: constants.CLEAR_LESSONS };

export const closeLessonModal = () => <const>{ type: constants.CLOSE_LESSON_MODAL };

export const markCLessonAsRead = (courseId: number | undefined, clessonId: number | undefined) =>
    <const>{ type: constants.MARK_CLESSON_AS_READ, courseId, clessonId };

export const getClessonReactionsRequest = (
    clessons: Array<CLessonInCourse>,
    classId: number | null,
    subject: SUBJECTS_SLUGS | null
) => <const>{ type: constants.GET_CLESSON_REACTIONS, clessons, classId, subject };
